// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"iP-z","categoryName":"jP-z","categoryNameSearchHeader":"kP-z","categoryContent":"lP-z","bottomAligned":"mP-z","image":"nP-z","imageNoBackground":"oP-z"};